export default "__VITE_ASSET__CmFIXw$5__"